export const isImageUrl = (url) => {
  if (typeof url !== 'string' || !url.trim()) {
    return false;
  }

  if (/\.(jpeg|jpg|gif|png|webp)(\?.*)?(#.*)?$/i.test(url)) {
    return true;
  }

  try {
    const parsedUrl = new URL(url);
    if (/\.(jpeg|jpg|gif|png|webp)$/i.test(parsedUrl.pathname)) {
      return true;
    }
  } catch (error) {
    // Fall through to provider-specific heuristics.
  }

  if (url.includes('blob.core.windows.net') && url.includes('img-')) {
    return true;
  }
  if (url.includes('firebasestorage.googleapis.com') || url.includes('storage.googleapis.com')) {
    return true;
  }
  return false;
};

export const convertToJPEG = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        canvas.toBlob((blob) => {
          const convertedFile = new File([blob], 'image.jpg', {
            type: 'image/jpeg',
          });
          resolve(convertedFile);
        }, 'image/jpeg', 0.8);
      };
      img.src = event.target.result;
    };
    reader.readAsDataURL(file);
  });
};
